<template>
    <div class="sub_contents">
        <div class="cont_center">
            <h1 class="title_page">기업 소개</h1>

            <div class="company_info_txt">
                <p class="company_info">
                    <span>하이비타민 기업복지 전문 마케팅 법인</span>입니다. <br>
                    국내 복지카드를 이용하는 300만 고객 대상으로 소비에 가치를 더하는 서비스 플랫폼을 <br>
                    구축하여 고객가치 창출에 앞장섭니다.
                </p>

                <p class="company_info">
                    고객가치 창출에 대한 끊임없는 연구와 투자를 통해 <br>
                    다양한 고객의 라이프스타일에 맞춰 특별한 혜택을 제공하여 고객과 함께 성장해 나가겠습니다.

                </p>
                HFO_HI_001
            </div>

            <div class="company_diagram_img">
                <img src="@/assets/images/company/company_diagram_img2.png" alt="" class="m_none">
                <img src="@/assets/images/m/company/company_diagram_img.jpg" alt="" class="pc_none">
            </div>

            <!-- [롤링테스트] 배너 코드 -->
            <!-- 권장: data-hvm-user-id 는 로그인 회원 고유 ID로 교체 -->
            <div data-hvm-zone="zone_trrk74dl" data-hvm-api-base="https://api.hivitamin.co.kr"
                data-hvm-bridge-origin="https://partner.hivitamin.co.kr" data-hvm-sub-id="HVM"
                data-hvm-user-id="iuxlUYWlxc8oKjEQUhmIXw==" style="width:300px;height:250px;overflow:hidden"></div>

            <!-- [혜택존1] 배너 코드 -->
            <!-- 권장: data-hvm-user-id 는 로그인 회원 고유 ID로 교체 -->
            <div data-hvm-zone="zone_4wc1s68d" data-hvm-api-base="https://api.hivitamin.co.kr"
                data-hvm-bridge-origin="https://partner.hivitamin.co.kr" data-hvm-sub-id="BENE_1"
                data-hvm-user-id="USER_ID" data-hvm-ent-uuid="ENT_UUID"
                style="width:300px;height:250px;overflow:hidden"></div>

        </div>


    </div>
</template>

<script>
export default {
    components: {

    },
    mounted() {
        if (typeof window !== 'undefined') {
            window.HVM_USER_ID = 'USER_ID';
        }
        this.mountEmbedScript();
    },
    methods: {
        mountEmbedScript() {
            if (typeof window === 'undefined') {
                return;
            }
            const scriptId = 'hvm-ad-embed-script';
            if (document.getElementById(scriptId)) {
                return;
            }
            const script = document.createElement('script');
            script.id = scriptId;
            script.async = true;
            script.src = 'https://partner.hivitamin.co.kr/hvm-ad-embed.js';
            document.body.appendChild(script);
        }

    }
}
</script>

<style lang="scss" scoped>
.stats_test_nav {
    margin: 20px 0;
}

.stats_test_link {
    display: inline-block;
    padding: 10px 14px;
    border: 1px solid #d4d4d8;
    border-radius: 8px;
    color: #111827;
    text-decoration: none;
    font-size: 14px;
}

.stats_test_link:hover {
    background-color: #f9fafb;
}
</style>